import { ContactForm } from '~/components/contact/ContactForm';

export default function CreateContactRoute() {
  return <ContactForm title='New Contact' />;
}
